/* eslint-disable */
export default {
  createCallLog: 'Oproeplijst maken',
  viewInSalesforce: 'Weergeven in Salesforce',
  createLog: 'Lijst maken',
} as const;

// @key: @#@"createCallLog"@#@ @source: @#@"Create call log"@#@
// @key: @#@"viewInSalesforce"@#@ @source: @#@"View in Salesforce"@#@
// @key: @#@"createLog"@#@ @source: @#@"Create log"@#@
